import dayjs from 'dayjs';

import { TypeAny } from 'src/interface';

export const formatDate = (
	date: any,
	format: string = 'DD MMMM YYYY, HH:mm',
	utc: boolean = false,
) => {
	if (!date) return '-';

	if (utc) {
		return (
			dayjs(date).format(format) +
			' (UTC' +
			dayjs(date).format('Z')?.split(':')?.[0] +
			')'
		).toUpperCase();
	} else {
		return dayjs(date).format(format);
	}
};

export const formatDateHowLongAgo = (date: any) => {
	const diffSecond = dayjs().diff(date, 'second');
	const diffMinute = dayjs().diff(date, 'minute');
	const diffHour = dayjs().diff(date, 'hour');
	const diffDay = dayjs().diff(date, 'day');
	const diffWeek = dayjs().diff(date, 'week');
	const diffMonth = dayjs().diff(date, 'month');
	const diffYear = dayjs().diff(date, 'year');

	if (!date) return '-';

	if (diffSecond < 60) {
		return `${diffSecond} second${diffSecond > 1 ? 's' : ''} ago`;
	} else if (diffMinute < 60) {
		return `${diffMinute} minute${diffMinute > 1 ? 's' : ''} ago`;
	} else if (diffHour < 24) {
		return `${diffHour} hour${diffHour > 1 ? 's' : ''} ago`;
	} else if (diffDay < 7) {
		return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
	} else if (diffWeek < 4) {
		return `${diffWeek} day${diffWeek > 1 ? 's' : ''} ago`;
	} else if (diffMonth < 12) {
		return `${diffMonth} month${diffMonth > 1 ? 's' : ''} ago`;
	} else {
		return `${diffYear} year${diffYear > 1 ? 's' : ''} ago`;
	}
};

export const calculateRemainingTime = (endDate: string) => {
	if (!endDate) {
		return '';
	}

	const end = dayjs(endDate);
	const now = dayjs();
	const diff = end.diff(now);

	if (diff <= 0) {
		return '';
	}

	const diffInSeconds = Math.floor(diff / 1000);
	const days = Math.floor(diffInSeconds / (3600 * 24));
	const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
	const minutes = Math.floor((diffInSeconds % 3600) / 60);

	return (
		`${days > 0 ? days + ' days ' : ''}` +
		`${hours > 0 ? hours + ' hours ' : ''}` +
		`${minutes > 0 ? minutes + ' minutes' : ''}`
	);
};

export const calculateOngoingTime = (startDate: string) => {
	if (!startDate) {
		return '';
	}

	const start = dayjs(startDate);
	const now = dayjs();

	const diff = now.diff(start);

	if (diff <= 0) {
		return '';
	}

	const diffInSeconds = Math.floor(diff / 1000);
	const days = Math.floor(diffInSeconds / (3600 * 24));
	const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
	const minutes = Math.floor((diffInSeconds % 3600) / 60);

	return (
		`${days > 0 ? days + ' days ' : ''}` +
		`${hours > 0 ? hours + ' hours ' : ''}` +
		`${minutes > 0 ? minutes + ' minutes' : ''}` +
		' ago'
	);
};

export const maturityDate = (days: number) => {
	const currentDate = new Date();
	currentDate.setDate(currentDate.getDate() + days);
	const options = { year: 'numeric', month: 'short', day: 'numeric' } as TypeAny;
	const futureDateStr = currentDate.toLocaleDateString('en-US', options);

	return futureDateStr;
};

export function toIsoString(date: any) {
	var tzo = -date.getTimezoneOffset(),
		dif = tzo >= 0 ? '+' : '-',
		pad = function (num: number) {
			return (num < 10 ? '0' : '') + num;
		};

	return (
		date.getFullYear() +
		'-' +
		pad(date.getMonth() + 1) +
		'-' +
		pad(date.getDate()) +
		'T' +
		pad(date.getHours()) +
		':' +
		pad(date.getMinutes()) +
		':' +
		pad(date.getSeconds()) +
		dif +
		pad(Math.floor(Math.abs(tzo) / 60)) +
		':' +
		pad(Math.abs(tzo) % 60)
	);
}
